/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：真正执行请求数据代码
 */
import Vue from 'vue'
import router from '../../router'
import axios from 'axios'
import vueAxios from 'vue-axios'
Vue.use(vueAxios, axios)
const fetch = ({ methods, url, data }) => {
  return new Promise((resolve, reject) => {
    Vue.axios[methods](url, data)
      .then(({ data: { code, message, data } }) => {
        // code为200时
        if (code === 200) {
          resolve(data)
        } else {
          Vue.$vux.loading.hide()
          if (code === 403 || code === 400) {
            // code为400、403时，将message通过toast直接抛出给用户看
            Vue.$vux.toast.show({ text: message, type: 'text' })
          } else if (code === 410) {
            showError(code, '未登录或登录失效，请重新登录', true)
            // router.push({path: '/isBind', query: {host: _HOST}})
          } else if (code === 401 || message.search('Your request was made with invalid credentials') !== -1) {
            showError(code, '未登录或登录失效，请重新登录', true)
            Vue.$vux.toast.text('系统错误(401)，请重新打开应用登录')
          } else {
            // code为其他时：0、8、401、500、501等等，统一抛出【系统错误，请重试！】
            Vue.$vux.toast.text('系统错误，请重试')
          }
          const err = {code, message, data}
          reject(err)
        }
      }).catch((err) => {
        console.log(err)
        // 当连接服务器失败时才执行这部分
        Vue.$vux.loading.hide()
        Vue.$vux.toast.text('网络错误，请刷新')
      })
  })
}

function showError(code, content, redirect) {
  const module = window.app.$module // 在main.js中由Vue.prototype.$module = module设置的
  const title = `系统错误(${code})`
  const buttonText = '知道了'

  Vue.$vux.alert.show({
    title: title,
    content: content,
    buttonText: buttonText,
    onHide () {
      if (redirect) {
        delete localStorage.access_token
        delete localStorage.privilege
        if (module === 'wxwork') {
          delete localStorage.user
          router.push({path: '/wxwork'})
        } else {
          router.push({path: '/login', query: {host: _HOST}})
        }
      }
    }
  })
}

export default fetch



// WEBPACK FOOTER //
// ./src/api/fetch/index.js